<div class="tw-text-base tw-font-medium tw-leading-normal tw-text-gray-800">Custom instructions</div>
<div class="tw-text-sm tw-leading-normal tw-text-gray-500">
  Terms, definitions and how you want answers worded. Burt Assistant follows them for everyone in this account, in
  Slides and Snapshot.
</div>
@if (instructions?.editable) {
<textarea
  rows="10"
  class="tw-resize-none tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-p-2.5 tw-font-[inherit] tw-text-sm tw-leading-normal tw-text-gray-700 tw-outline-none focus:tw-border-burt-purple"
  placeholder="For example: we call impressions views, and a tactic is a line item type."
  aria-label="Custom instructions"
  [maxlength]="instructions.max"
  [(ngModel)]="draft"
  (ngModelChange)="onInput()"
></textarea>
<div class="tw-flex tw-items-center tw-gap-2">
  <span class="tw-text-xs tw-text-gray-500">{{ draft.length }} / {{ instructions.max }}</span>
  <div class="tw-flex-1"></div>
  @if (savedVisible) {
  <span class="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-font-medium tw-text-gray-700">
    <i class="fa-solid fa-circle-check tw-text-green-600"></i>
    Saved
  </span>
  } @else if (note) {
  <span class="tw-text-xs tw-text-gray-500">{{ note }}</span>
  }
  <button
    type="button"
    class="tw-cursor-pointer tw-rounded-full tw-border-0 tw-bg-burt-purple tw-px-3 tw-py-1.5 tw-font-[inherit] tw-text-[13px] tw-font-semibold tw-text-white hover:tw-bg-purple-600 disabled:tw-cursor-default disabled:tw-opacity-40"
    [disabled]="!changed || saving"
    (click)="save()"
  >
    Save
  </button>
</div>
} @else if (instructions) {
<div
  class="tw-whitespace-pre-line tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-bg-gray-50 tw-p-2.5 tw-text-sm tw-leading-normal tw-text-gray-700"
>
  {{ instructions.text || 'No instructions yet.' }}
</div>
<div class="tw-text-xs tw-text-gray-500">Only account admins can change these.</div>
} @else {
<div class="tw-text-sm tw-text-gray-500">{{ note || 'Loading…' }}</div>
}
